const BASE_URL = process.env.REACT_APP_API_BASE_URL;

const routes = {
    reports: {endpoint: `${BASE_URL}/report`, path: '/reports', pageTitle: 'Reports', menuTitle: 'Reports'},
    violations: {endpoint: `${BASE_URL}/ad`, path: '/violations', pageTitle: 'Violations', menuTitle: 'Violations'},
    brands: {endpoint: `${BASE_URL}/brand`, path: '/brands', pageTitle: 'Your Brands', menuTitle: 'Brands'},
    agencies: {endpoint: `${BASE_URL}/agency`, path: '/agencies', pageTitle: 'Agency Management', menuTitle: 'Agencies'},
    users: {endpoint: `${BASE_URL}/user`, path: '/users', pageTitle: 'User Management', menuTitle: 'Users'},
    searchTerms: {
        searchTerms: {path: 'searchterms'},
        genericTerms: {path: 'chemicalnames'},
        onLabelTerms: {path: 'onlabelterms'},
        offLabelTerms: {path: 'offlabelterms'}
    },
    rule: {endpoint: `${BASE_URL}/rule`},
    adProvider: {endpoint: `${BASE_URL}/adprovider`},
    brandUrls: {endpoint: `${BASE_URL}/brandurl`},
    searchTerm: {endpoint: `${BASE_URL}/searchterm`},
     userAgent: {endpoint: `${BASE_URL}/api/user-agents`, path: '/user-agent', pageTitle: 'User Agent', menuTitle: 'User Agent'},
    userAgent: {endpoint: `${BASE_URL}/api/user-agents`, path: '/user-agent', pageTitle: 'User Agent', menuTitle: 'User Agent'},
    
};

export default routes;
